import React, { Component } from 'react';
import { Button, notification, Icon, Input } from 'antd';
import PropTypes from 'prop-types';
import api from '../../../../../../services/api';
import './styles.css';

export default class Telefone extends Component {
  static propTypes = {
    acordo_id: PropTypes.number,
    telefone: PropTypes.string
  };

  state = {
    telefone: this.props.telefone || '',
    active: false,
    loading: false
  };

  handleChange = event => {
    this.setState({
      telefone: event.target.value
    });
  };

  handleSalvar = async () => {
    this.setState({ loading: true });

    try {
      await api.patch(`/acordo/acordos/${this.props.acordo_id}/`, {
        telefone: this.state.telefone
      });

      notification.success({
        message: 'Telefone atualizado.'
      });

      this.setState({ active: false });
    } catch (err) {
      console.error(err);
      notification.error({
        message: 'Não foi possível salvar o telefone.'
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCancel = () => {
    this.setState({
      telefone: this.props.telefone || '',
      active: false
    });
  };

  render() {
    if (!this.state.active) {
      return (
        <div className="telefone__display">
          <span>{this.state.telefone || '(Não informado)'}</span>
          <Button
            size="small"
            icon="edit"
            onClick={() => this.setState({ active: true })}
            style={{ marginLeft: 8 }}
          />
        </div>
      );
    }

    return (
      <div className="telefone__edit">
        <Input
          value={this.state.telefone}
          onChange={this.handleChange}
          placeholder="(00) 00000-0000"
          disabled={this.state.loading}
          style={{ width: 180 }}
        />
        <Button
          size="small"
          type="primary"
          icon="check"
          loading={this.state.loading}
          onClick={this.handleSalvar}
          style={{ marginLeft: 8 }}
        />
        <Button
          size="small"
          icon="close"
          disabled={this.state.loading}
          onClick={this.handleCancel}
          style={{ marginLeft: 4 }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Pasta/Acordos/AcordoView/AcordoInfos/Telefone/index.jsx